const validate = values => {
	const errors = {}

	return {}
}

export default validate
